export function supabaseAuthStorageKey(supabaseUrl: string): string {
  try {
    const projectReference = new URL(supabaseUrl).hostname.split('.')[0];
    return projectReference ? `sb-${projectReference}-auth-token` : 'sb-auth-token';
  } catch {
    return 'sb-auth-token';
  }
}
